var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-card-content',[_c('md-progress-bar',{staticClass:"md-primary mt24",attrs:{"md-mode":"indeterminate"}}),_c('p',{staticStyle:{"text-align":"center"}},[_vm._v("Estamos procesando la información, espere un momento")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }